export default {
  BASE_URL: '/cb/payment/register/reverse',
  api: [
    // 冲销项目收款
    {
      name: 'list',
      desc: '冲销项目收款列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'detail',
      desc: '冲销项目收款详情',
      method: 'GET',
      path: '/detail'
    },
    {
      name: 'add',
      desc: '新增收款登记',
      method: 'POST',
      path: '/add'
    },
    {
      name: 'submit',
      desc: '绑定提交',
      method: 'POST',
      path: '/bind'
    },
    {
      name: 'delete',
      desc: '删除',
      method: 'POST',
      path: '/del'
    },
    {
      name: 'import',
      desc: '导入收款登记',
      method: 'POST',
      path: '/import'
    },
    {
      name: 'importTemplate',
      desc: '导入收款登记模板',
      method: 'GET',
      path: '/import/tempInstall'
    },
    {
      name: 'import',
      desc: '导入登记',
      method: 'POST',
      path: '/import'
    },
    {
      name: 'log',
      desc: '推送',
      method: 'GET',
      path: '/log/list'
    },
    {
      name: 'push',
      desc: '推送',
      method: 'POST',
      path: '/push/kinDee'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/statement/receipt.js